<template>
	<transition name="fade">
	<!-- Start Page Content -->
	<div id="dashboard">

		<!-- ── Admin message ──────────────────────────────── -->
		<div v-if="DashboardText && !isArchives" class="va-info-box">
			<div class="db-message-title"><i class="fa-light fa-circle-info"></i> Message from Bungalow 7 Clients</div>
			<div v-html="DashboardText"></div>
		</div>

		<!-- ── Client selector (multi-client users only) ──── -->
		<div v-if="!OrganizationIDAccess" class="va-selector-bar">
			<div class="va-selector-item">
				<div class="va-selector-label">Clients</div>
				<el-select key="orgSelect" v-model="OrganizationIDs" class="oneHundred" placeholder="Clients" @change="getInitialData" multiple default-first-option filterable clearable>
					<el-option
							v-for="item in Organizations"
							:label="item.OrganizationName"
							:value="item.OrganizationID"
							:key="item.OrganizationID">
					</el-option>
				</el-select>
			</div>
		</div>

		<!-- ── Account overview card ───────────────────────── -->
		<div class="va-page-card">
			<div class="va-page-card-header">
				<div class="va-page-card-dot"></div>
				<span class="va-page-card-title">Account Overview</span>
			</div>
			<div class="va-page-card-body">
				<div class="db-overview-grid">
					<div class="db-overview-col">
						<div class="db-overview-label">Welcome</div>
						<img v-if="organization.Params.ClientLogo" class="client-logo" :src="organization.Params.ClientLogo" alt="Client Logo">
						<div class="db-welcome-name">{{ currentUser.FirstName + ' ' + currentUser.LastName }}</div>
						<div class="db-welcome-email"><i class="fa-light fa-envelope"></i> {{ currentUser.EmailAddress }}</div>
					</div>
					<div class="db-overview-col">
						<div class="db-overview-label">Latest Downloads</div>
						<div v-if="latest.length == 0" class="va-selector-empty"><i class="fa-light fa-circle-info"></i> No Downloaded Files Yet</div>
						<div v-else class="db-download-list">
							<div v-for="(file, index) in latest" :key="index" class="db-download-row">
								<span class="db-download-name">{{ file.ClientFileName }}</span>
								<span class="db-download-date">{{ file.DownLoadDate }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ── File library card ───────────────────────────── -->
		<div class="va-page-card">
			<div class="va-page-card-header">
				<div class="va-page-card-dot"></div>
				<span class="va-page-card-title">{{ isArchives ? 'Archives' : (isHistorical ? 'Historical Files' : (isFavorites ? 'Favorites' : 'File Library')) }}</span>
				<span class="va-page-card-count" v-if="count > 0">{{ count }}</span>
				<div class="db-header-controls">
					<el-input
							class="db-search"
							v-model="search"
							size="default"
							clearable
							@keyup.enter="fileFilter"
							@clear="fileFilter"
							placeholder="Type to search"/>
					<el-button size="default" type="primary" @click="fileFilter"><i class="fa-light fa-magnifying-glass"></i>&ensp;Search</el-button>
				</div>
			</div>

			<div v-loading="loading" class="va-page-card-body">

				<div class="db-filter-bar">
					<el-select key="select1" size="small" class="db-filter-select db-filter-bpm" v-model="bpm" @change="fileFilter" placeholder="BPM" default-first-option filterable clearable>
						<el-option
								v-for="item in BPMs"
								:key="item.SpecName"
								:label="item.SpecName"
								:value="item.SpecName">
						</el-option>
					</el-select>
					<el-select key="select2" size="small" class="db-filter-select db-filter-genre" v-model="genre" @change="fileFilter" placeholder="Genre" default-first-option filterable clearable>
						<el-option
								v-for="item in Genres"
								:key="item.SpecName"
								:label="item.SpecName"
								:value="item.SpecName">
						</el-option>
					</el-select>
					<el-select key="select3" size="small" class="db-filter-select db-filter-mood" v-model="mood" @change="fileFilter" placeholder="Mood" default-first-option filterable clearable>
						<el-option
								v-for="item in Moods"
								:key="item.SpecName"
								:label="item.SpecName"
								:value="item.SpecName">
						</el-option>
					</el-select>
					<el-select key="select4" size="small" class="db-filter-select db-filter-format" v-model="format" @change="fileFilter" placeholder="Format" default-first-option filterable clearable>
						<el-option
								v-for="item in Formats"
								:key="item.SpecName"
								:label="item.SpecName"
								:value="item.SpecName">
						</el-option>
					</el-select>
					<el-select key="select5" size="small" class="db-filter-select db-filter-length" v-model="length" @change="fileFilter" placeholder="Length" default-first-option filterable clearable>
						<el-option
								v-for="item in Lengths"
								:key="item.SpecName"
								:label="item.SpecName"
								:value="item.SpecName">
						</el-option>
					</el-select>
					<el-button type="primary" class="db-bulk-download" @click="bulkFileDownload();">
						<i class="fa-light fa-download"></i>&ensp;Download all Selected
					</el-button>
				</div>

				<el-table class="mt-1"
						  :data="PageFiles"
						  border
						  key="tablefiles"
						  size="small"
						  max-height="600"
						  empty-text="No Files Available"
						  @sort-change="sortFile"
						  stripe
						  style="width: 100%">
					<el-table-column
							prop="sample"
							label="Sample"
							align="center"
							width="75">
						<template #default="scope">
							<template v-if="scope.row.FileType == 'audio'" >
								<i v-if="scope.row.samplePlaying == 'n'" class="fa-light fa-circle-play db-sample-icon" @click="playSound((scope.row.SampleURL ? scope.row.SampleURL : scope.row.FullURL));scope.row.samplePlaying = 'y';"></i>
								<i v-else class="fa-light fa-circle-pause db-sample-icon db-sample-icon--playing" @click="stopSound((scope.row.SampleURL ? scope.row.SampleURL : scope.row.FullURL));scope.row.samplePlaying = 'n';"></i>
							</template>
							<template v-else>
							</template>
						</template>
					</el-table-column>
					<el-table-column
						prop="ClientFileName"
						label="Name"
						sortable="custom"
					>
					</el-table-column>
					<el-table-column
						prop="OrganizationNames"
						label="Client(s)"
						sortable="custom"
						width="150"
					>
						<template #default="scope">
							<div v-html="scope.row.OrganizationNames"></div>
						</template>
					</el-table-column>
					<el-table-column
							prop="TimeAgo"
							label="Uploaded"
							width="100"
					>
					</el-table-column>
					<el-table-column
							prop=""
							label="Properies"
					>
						<template #default="scope">
							<div v-if="scope.row.BPM" class="db-prop-line">BPM: {{scope.row.BPM}}</div>
							<div v-if="scope.row.Mood" class="db-prop-line">Mood: {{scope.row.Mood}}</div>
							<div v-if="scope.row.Length" class="db-prop-line">Length: {{scope.row.Length}}</div>
							<div v-if="scope.row.Genre" class="db-prop-line">Genre: {{scope.row.Genre}}</div>
							<div v-if="scope.row.Format" class="db-prop-line">Format: {{scope.row.Format}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="Duration"
						label="Duration"
						width="110"
						align="center"
						sortable="custom"
					>
						<template #default="scope">
							<span v-html="(!scope.row.Duration || scope.row.Duration == 0 ? '' : scope.row.DurationF)"></span>
						</template>
					</el-table-column>
					<el-table-column
						prop="Notes"
						label="Notes"
						min-width="200"
					>
						<template #default="scope">
							<textarea class="el-textarea__inner" v-model="scope.row.FileNotes" @change="changedNotes(scope.row)"></textarea>
						</template>
					</el-table-column>
					<el-table-column
						prop="Favorite"
						label="Favorite"
						width="110"
						align="center"
						sortable
					>
						<template #default="scope">
							<span v-if="scope.row.Favorite != 'y'" class="db-favorite" @click="changedFavorite(scope.row)"><i class="fa-light fa-star"></i></span>
							<span v-else class="db-favorite db-favorite--active" @click="changedFavorite(scope.row)"><i class="fa-solid fa-star"></i></span>
						</template>
					</el-table-column>

					<el-table-column
						v-if="!isHistorical"
						prop="file"
						label="Select for Download"
						width="180"
						align="center"
					>
						<template #default="scope">
							<el-checkbox v-model="scope.row.selected" class="downloadcheckbox"></el-checkbox>
							<el-button v-if="scope.row.downloading != 'y'" type="primary" class="downloadbutton" @click="forceFileDownload(scope.row)" ><i class="fa-light fa-download"></i>&ensp;Download</el-button>
							<el-button v-else type="success" class="downloadbutton" :loading="true" >Downloading</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="db-pagination">
					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							background
							:hide-on-single-page="singlePage"
							:current-page.sync="currentPage"
							:page-sizes="[100, 500, 1000, 2000]"
							:page-size="sizePerPage"
							layout="sizes, prev, pager, next"
							:total="count">
					</el-pagination>
				</div>
				<audio ref="audioPlayer" :src="currentFile" autoplay="true" preload="none"
					   v-on:ended="stopSound()"></audio>
			</div>
		</div>

	</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import Util from '../assets/js/util.js';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
export default {
	name: 'Dashboard',
	data () {
		return {
			loading : false,
            currentStatus : 0,
			currentPage: 1,
			count: 0,
			sizePerPage: 100,
			singlePage : false,
			Files: [],
			FilteredFiles: [],
			PageFiles : [],
			Organizations : [],
			OrganizationIDs : [],
			organization: {Params : []},
			latest: [],
			DashboardText : '',
			audio : '',
			currentFile : '',
			search : '',
			bpm : '',
			genre : '',
			mood : '',
			format :'',
			length : '',
			BPMs : [],
			Genres : [],
			Moods : [],
			Formats : [],
			Lengths: [],
		}
	},
	props:["config"],
	computed: {
		...mapGetters({ currentUser: 'currentUser' }),
		...mapGetters({ componentIDs: 'componentIDs' }),

		createAccess () {
			return Util.createAccess(this.currentUser);
		},
		modifyAccess () {
			return Util.modifyAccess(this.currentUser);
		},
		OrganizationIDAccess () {
			return Util.OrganizationIDAccess(this.currentUser);
		},
        isArchives () {
          return (this.$route.fullPath.indexOf('chives') !== -1 ? true : false);
        },
        isHistorical () {
            return (this.$route.fullPath.indexOf('istorical') !== -1 ? true : false);
        },
        isFavorites () {
            return (this.$route.fullPath.indexOf('avorite') !== -1 ? true : false);
        },

    },
    methods: {
        changedFavorite (row) {
            if (row.Favorite !='y') {
                row.Favorite = 'y';
            } else {
                row.Favorite = 'n';
            }
            this.updateMetadata (row);
        },
        changedNotes (row) {
            this.updateMetadata (row);
        },
	    handleSizeChange(val) {
		    this.sizePerPage = val;
		    this.pageFilter();
	    },
	    handleCurrentChange(val) {
		    this.currentPage = val;
		    this.pageFilter();
	    },
		pageFilter () {
	    	this.PageFiles = [];
	    	let start = (this.currentPage-1) * this.sizePerPage;
			for (let i=0; i < this.FilteredFiles.length; i++) {
				if (i >= start && this.PageFiles.length <= this.sizePerPage) {
					this.PageFiles.push(this.FilteredFiles[i]);
				}
			}
			if (start == 0 && this.PageFiles.length < this.sizePerPage) {
				this.singlePage = true;
			} else {
				this.singlePage = false;
			}
		},
	    fileFilter() {
		    var goodFiles = [];
		    var count = 0;
		    for (let i=0; i < this.Files.length; i++) {
			    var includeFile = true;

			    if (this.search && !this.Files[i].FileName.toLowerCase().includes(this.search.toLowerCase()) && !this.Files[i].ClientFileName.toLowerCase().includes(this.search.toLowerCase())) {
				    includeFile = false;
			    } else {
					includeFile = true;
				}
			    if (this.bpm && this.bpm != this.Files[i].BPM) {
				    includeFile = false;
			    }
			    if (this.genre && this.genre != this.Files[i].Genre) {
				    includeFile = false;
			    }
			    if (this.mood && this.mood != this.Files[i].Mood) {
				    includeFile = false;
			    }
			    if (this.format && this.format != this.Files[i].Format) {
				    includeFile = false;
			    }
			    if (this.length && this.length != this.Files[i].Length) {
				    includeFile = false;
			    }
			    if (includeFile) {
				    goodFiles.push(this.Files[i]);
			    }
		    }
		    this.FilteredFiles = goodFiles;
		    this.count = this.FilteredFiles.length;
		    this.currentPage = 1;
		    this.pageFilter();
	    },
      sortFile(data) {

        if (data.prop == 'TimeAgo') {
          data.prop = 'TimeAgoSort';
        }
        this.Files.sort(function(a, b) {
            if (data.prop == 'Duration') {
                if (data.order == 'ascending') {
                    var labelA = parseInt(a[data.prop].toString().toLowerCase().trim()),
                        labelB = parseInt(b[data.prop].toString().toLowerCase().trim());
                } else {
                    var labelB = parseInt(a[data.prop].toString().toLowerCase().trim()),
                        labelA = parseInt(b[data.prop].toString().toLowerCase().trim());
                }
                var result = labelA - labelB;

                return result;
            } else {
                if (data.order == 'ascending') {
                    var labelA = a[data.prop].toString().toLowerCase().trim(),
                        labelB = b[data.prop].toString().toLowerCase().trim();
                } else {
                    var labelB = a[data.prop].toString().toLowerCase().trim(),
                        labelA = b[data.prop].toString().toLowerCase().trim();
                }
                if (labelA < labelB) { //sort string ascending
                    return -1;
                } else if (labelA > labelB) {
                    return 1
                } else {
                    return 0 //default return value (no sorting)
                }
            }
        });
        this.fileFilter();
      },
	    playSound(file) {
	    	if (this.currentFile) {
			    this.stopSound();
		    }
		    this.currentFile = file;
            this.audio = this.$refs.audioPlayer;
		    var playPromise = this.audio.play();

		    if (playPromise !== undefined) {
			    playPromise.then(_ => {
			    })
				    .catch(error => {

				    });
		    }
	    },
	    stopSound() {
		    this.currentFile = '';
		    for (let i=0; i < this.PageFiles.length; i++) {
		    	this.PageFiles[i]['samplePlaying'] = 'n';
		    }
            this.audio = this.$refs.audioPlayer;

		    var playPromise = this.audio.pause();

		    if (playPromise !== undefined) {
			    playPromise.then(_ => {
			    })
				    .catch(error => {

                    });
		    }
	    },
        bulkFileDownload () {
            var FileIDs = [];
            for (let i=0; i < this.PageFiles.length; i++)
            {
                if (this.PageFiles[i].selected) {
                    FileIDs.push(this.PageFiles[i].FileID);
                    this.PageFiles[i].downloading = 'y';
                }
            }

            axios.post('/files/bulkdownload', {FileIDs : FileIDs}
            )
                .then(response => {
                    if (response.data.result == 'success') {
                        const link = document.createElement('a');
                        link.href = response.data.FileURL;
                        var filename = response.data.FileURL.replace(/^.*[\\\/]/, '')
                        link.setAttribute('download', filename) //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        for (let i=0; i < this.PageFiles.length; i++)
                        {
                            if (this.PageFiles[i].selected) {
                                this.PageFiles[i].selected = '';
                                this.PageFiles[i].downloading = 'n';
                            }
                        }
                    } else {
                        this.$notify({
                            title: 'Error',
                            message: "Files cannot be Downloaded",
                            type: 'error',
                            duration: 2000,
                            showClose: false
                        });
                    }
                }).catch(response => {
            });
        },
	    forceFileDownload(row){
            for (let i=0; i < this.PageFiles.length; i++)
            {
                if (this.PageFiles[i].FileID == row.FileID) {
                    this.PageFiles[i].downloading = 'y';
                    break;
                }
            }
		    axios.post('/files/download', {FileID : row.FileID}
		    )
			    .then(response => {
					if (response.data.result == 'success') {
						const link = document.createElement('a');
						link.href = response.data.FileURL;
						var filename = response.data.FileURL.replace(/^.*[\\\/]/, '')
						link.setAttribute('download', filename) //or any other extension
						document.body.appendChild(link);
						link.click();
                        for (let i=0; i < this.PageFiles.length; i++)
                        {
                            if (this.PageFiles[i].FileID == row.FileID) {
                                this.PageFiles[i].downloading = 'n';
                                break;
                            }
                        }
					} else {
						this.$notify({
							title: 'Error',
							message: "File cannot be Downloaded",
							type: 'error',
							duration: 2000,
							showClose: false
						});
					}
			    }).catch(response => {
		    });
	    },
	    getOrganizations () {
		    var tables = ['Organizations'];
		    axios.post('/index/tableData', {'tables': tables },
		    )
			    .then(response => {
				    if (response.data.result == 'success') {
					    for (let value of tables) {
						    this[value] = response.data[value];
					    }
					    this.getInitialData();
				    }
			    }).catch(response => {
		    });
	    },
	    getInitialData () {
		    this.loading = true;
		    axios.post('/index/dashboard', {Archived : (this.isArchives ? 'y' : (this.isHistorical ? 'h' : (this.isFavorites ? 'f' : 'n'))), OrganizationIDs : this.OrganizationIDs}
		    )
			    .then(response => {
				    if (response.data.result == 'success') {
					    this.Files = (response.data.Files ? response.data.Files : []);
					    this.organization = response.data.organization;
					    this.latest = (response.data.latest ? response.data.latest : []);
					    this.fileFilter();
					    this.Genres = (response.data.Genres ? response.data.Genres : []);
					    this.Moods = (response.data.Moods ? response.data.Moods : []);
					    this.BPMs = (response.data.BPMs ? response.data.BPMs : []);
					    this.Lengths = (response.data.Lengths ? response.data.Lengths : []);
					    this.Formats = (response.data.Formats ? response.data.Formats : []);
				    }
				    this.loading = false;
			    }).catch(response => {
			    this.loading = false;;
		    });
	    },
        updateMetadata (row) {
            axios.post('/files/savemetadata', {file : row}
            )
                .then(response => {
                    if (response.data.result == 'success') {
                        this.currentStatus = STATUS_INITIAL;
                        if (response.data.FileMetadataID) {
                            row.FileMetadataID = response.data.FileMetadataID;
                        }
                    } else {
                        this.currentStatus = STATUS_FAILED;
                        this.displayPopup(response.data.message);
                    }
                }).catch(response => {
                    this.currentStatus = STATUS_FAILED;
                    this.displayPopup('We encountered an error saving your data');
            });
        },
        displayPopup (message) {
            this.$alert(message,  {
                type: 'error',
                confirmButtonText: 'OK',
            });
        }
    },
	mounted() {
		this.getOrganizations();
	},
}
</script>

<style>
	.dashboard div.el-table th {
		font-weight: 800;
	}
	.dashboard div.el-table .cell {
		word-break: normal;
	}
	#app.dashboard .el-collapse-item__header {
		font-size: 15px;
	}
	#app.dashboard .el-collapse-item__content {
		padding-bottom: 0;
	}
	#app.dashboard .el-table .cell {
		line-height: 17px;
	}
	#app.dashboard .el-table__fixed-footer-wrapper tbody td div.cell {
		font-size: 16px;
		font-weight: 800;
		color: #000;
	}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	a {
		color: var(--el-color-primary, #3F9CA8);
	}
	table {
		width: 100%;
	}
	.el-select {
		width: 100%;
		max-width: 300px;
	}

	/* ── Admin message ────────────────────────────────────── */
	.db-message-title {
		font-size: 11px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.06em;
		margin-bottom: 4px;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	/* ── Account overview ─────────────────────────────────── */
	.db-overview-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 28px;
	}
	@media (max-width: 700px) {
		.db-overview-grid { grid-template-columns: 1fr; }
	}
	.db-overview-label {
		font-size: 10.5px;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.08em;
		color: var(--el-text-color-secondary, #64748B);
		margin-bottom: 8px;
	}
	.client-logo {
		display: block;
		max-width: 60%;
		max-height: 48px;
		object-fit: contain;
		margin-bottom: 10px;
	}
	.db-welcome-name {
		font-family: 'Chakra Petch', sans-serif;
		font-size: 18px;
		font-weight: 600;
		color: var(--el-text-color-primary, #1E293B);
		margin-bottom: 4px;
	}
	.db-welcome-email {
		font-size: 13px;
		color: var(--el-text-color-secondary, #64748B);
		display: flex;
		align-items: center;
		gap: 6px;
	}
	.db-download-list {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}
	.db-download-row {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		gap: 12px;
		font-size: 13px;
		padding: 6px 0;
		border-bottom: 1px solid var(--el-border-color-lighter, #EDF1F5);
	}
	.db-download-row:last-child { border-bottom: none; }
	.db-download-name {
		color: var(--el-text-color-primary, #1E293B);
		font-weight: 500;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.db-download-date {
		color: var(--el-text-color-secondary, #64748B);
		font-size: 12px;
		flex-shrink: 0;
	}

	/* ── File library header controls ─────────────────────── */
	.db-header-controls {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-left: auto;
		flex-wrap: wrap;
	}
	.db-search { width: 220px; }

	/* ── Filter bar ────────────────────────────────────────── */
	.db-filter-bar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
		margin-bottom: 14px;
	}
	#app .db-filter-select { width: 100%; max-width: unset; flex: 0 0 auto; }
	#app .db-filter-bpm    { width: 120px; }
	#app .db-filter-genre  { width: 180px; }
	#app .db-filter-mood   { width: 180px; }
	#app .db-filter-format { width: 120px; }
	#app .db-filter-length { width: 150px; }
	#app .db-bulk-download { margin-left: auto; }

	/* ── Table cell content ───────────────────────────────── */
	.db-prop-line {
		width: 100%;
		line-height: 14px;
		overflow-wrap: break-word;
	}
	.db-sample-icon {
		font-size: 19px;
		cursor: pointer;
		color: var(--el-color-primary, #3F9CA8);
	}
	.db-sample-icon--playing { color: var(--el-color-warning, #D97706); }
    .db-favorite {
        color: #94A3B8;
        cursor: pointer;
        font-size: 16px;
    }
    .db-favorite--active {
        color: #E6A23C;
        cursor: pointer;
        font-size: 16px;
    }
    .downloadcheckbox {
        float:left;
        margin-right: 20px !important;
    }
    .downloadbutton {
        float:left;
    }

	/* ── Pagination ────────────────────────────────────────── */
	.db-pagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 14px;
	}
</style>
